import { render, staticRenderFns } from "./HistoryHot.vue?vue&type=template&id=70269c46&scoped=true&"
import script from "./HistoryHot.vue?vue&type=script&lang=js&"
export * from "./HistoryHot.vue?vue&type=script&lang=js&"
import style0 from "./HistoryHot.vue?vue&type=style&index=0&id=70269c46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70269c46",
  null
  
)

export default component.exports